export default __webpack_public_path__ + "static/bg-466768908350e644f3db36b4ccfac7cd.jpg";